import React from 'react';
import { Provider, ErrorBoundary } from '@rollbar/react'
import Rollbar from 'rollbar';

const rollbarConfig = {
    enabled: Boolean(import.meta.env.FRONTEND_ROLLBAR_TOKEN),
    accessToken: import.meta.env.FRONTEND_ROLLBAR_TOKEN || 'disabled',
    environment: import.meta.env.MODE || 'development',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
        code_version: '123'
    }
}

export const rollbarInstance = new Rollbar(rollbarConfig);

export default function RollbarBoundary(props) {
    return (
        <Provider instance={rollbarInstance}>
            <ErrorBoundary>
                {props.children}
            </ErrorBoundary>
        </Provider>
    )
}